/**************************************************
 * Nombre:       Seccion_Detalle_Sostenibilidad
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Detalle_Sos_Portada from "./Componentes/Detalle_Sos_Portada";
import Detalle_Sos_Galeria from "./Componentes/Detalle_Sos_Galeria";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import Equipo from "./Componentes/Equipo";
import {irArriba} from "../../Utilidades/irArriba";

const Seccion_Detalle_Sostenibilidad = () => {
    const parms = useParams()
    const [post, setPost] = useState({})

    useEffect(() => {
        irArriba()

        if (parms && parms.id) {
            obtenerDoc('sostenibilidad', parms.id).then((dox) => {
                if (dox.res) {
                    setPost(dox.data)
                }
            })
        }

    }, [parms]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                <Detalle_Sos_Portada item={post}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Detalle_Sos_Galeria item={post}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                <Equipo/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Detalle_Sostenibilidad